import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "No data available yet. Please click the button in Child Component 1.", -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.localReceivedData && _ctx.localReceivedData.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", null, "Received Boolean Data: " + _toDisplayString(_ctx.localReceivedData.isDataTrueList), 1),
          _createElementVNode("p", null, "Received ID: " + _toDisplayString(_ctx.localReceivedData.id), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4)),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleUpdateDataEdit && _ctx.handleUpdateDataEdit(...args)))
    }, "Update Data"),
    _createElementVNode("p", null, "Received isDataTrueList: " + _toDisplayString(_ctx.isDataTrueList), 1)
  ]))
}